<div class="modal-content">
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
    >
    <div class="modal-title">
      <h4 class="mb-0">Enter ID</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModalClick()"
      >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <form
    [formGroup]="id_form"
    class="modal-body pb-4 mt-3"
    (ngSubmit)="saveId()"
    autocomplete="off"
    >
    <div class="d-flex flex-column gap-3">
      <!-- ID Type -->
      <div class="row align-items-center">
        <div
          class="col-sm-4 d-flex align-items-center justify-content-end mb-0"
          >
          @if (id_form.getRawValue().id_type === 'drivers_license') {
            <button
              type="button"
              class="btn modern-btn primary-btn btn-sm me-3 px-3 py-1"
              (click)="openScanIdAndBlur($event)"
              [disabled]="scanIdModalOpen"
              tooltip="Scan Drivers License"
              >
              <i class="fa-solid fa-address-card"></i>
            </button>
          }
          <label for="id_type" class="form-label mb-0 text-end">
            <span class="text-danger">*</span>ID Type:
          </label>
        </div>
        <div class="col-sm-8 flex-grow-1">
          <ng-select
            [items]="id_types"
            bindLabel="label"
            bindValue="value"
            placeholder="Select ID Type"
            formControlName="id_type"
            [searchable]="false"
            class="form-control modern-input text-uppercase w-100 p-0 border-0 bg-transparent"
          ></ng-select>
        </div>
      </div>

      <!-- Issuing Authority -->
      <div class="row align-items-center">
        <label class="col-sm-4 col-form-label form-label text-end mb-0">
          <span class="text-danger">*</span>Issuing Authority:
        </label>
        <div class="col-sm-8 flex-grow-1">
          <ng-select
            [items]="issuing_authorities"
            bindLabel="label"
            bindValue="value"
            placeholder="Select Issuing Authority"
            formControlName="issuing_authority"
            [searchable]="false"
            class="form-control modern-input text-uppercase w-100 p-0 border-0 bg-transparent"
          ></ng-select>
        </div>
      </div>

      <!-- ID Number -->
      <div class="row align-items-center">
        <label class="col-sm-4 col-form-label form-label text-end mb-0">
          <span class="text-danger">*</span>ID Number:
        </label>
        <div class="col-sm-8 flex-grow-1">
          <input
            type="text"
            class="form-control modern-input w-100"
            formControlName="id_number"
            />
          </div>
        </div>

        <!-- First Name -->
        <div class="row align-items-center">
          <label class="col-sm-4 col-form-label form-label text-end mb-0">
            <span class="text-danger">*</span>First Name:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="name_first"
              />
            </div>
          </div>

          <!-- Middle Name -->
          <div class="row align-items-center">
            <label class="col-sm-4 col-form-label form-label text-end mb-0">
              <span class="text-danger">*</span>Middle Name:
            </label>
            <div class="col-sm-8 flex-grow-1">
              <input
                type="text"
                class="form-control modern-input w-100"
                formControlName="name_middle"
                />
              </div>
            </div>

            <!-- Last Name -->
            <div class="row align-items-center">
              <label class="col-sm-4 col-form-label form-label text-end mb-0">
                <span class="text-danger">*</span>Last Name:
              </label>
              <div class="col-sm-8 flex-grow-1">
                <input
                  type="text"
                  class="form-control modern-input w-100"
                  formControlName="name_last"
                  />
                </div>
              </div>

              <!-- Birth Date -->
              <div class="row align-items-center">
                <label class="col-sm-4 col-form-label form-label text-end mb-0">
                  <span class="text-danger">*</span>Birth Date:
                </label>
                <div class="col-sm-8 flex-grow-1">
                  <div class="position-relative w-100">
                    <input
                      #birth_date="bsDatepicker"
                      type="text"
                      class="form-control modern-input text-uppercase w-100"
                      formControlName="birth_date"
                      id="birth_date"
                      placeholder="MM/DD/YYYY"
                      [bsConfig]="bsConfig"
                      [readOnly]="false"
                      bsDatepicker
                      appDateFormat
                      />
                      <i
                        class="fa-solid fa-calendar position-absolute"
              style="
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                color: #888;
              "
                        (click)="birth_date.show()"
                      ></i>
                    </div>
                    @if (
                      id_form.get('birth_date')?.errors?.['minimumAge'] &&
                      id_form.get('birth_date')?.touched
                      ) {
                      <div
                        class="text-danger mt-1 small"
                        >
                        Must be at least
                        {{
                        id_form.get("birth_date")?.errors?.["minimumAge"].required
                        }}
                        years old.
                      </div>
                    }
                  </div>
                </div>

                <!-- Issue Date -->
                <div class="row align-items-center">
                  <label class="col-sm-4 col-form-label form-label text-end mb-0">
                    <span class="text-danger">*</span>Issue Date:
                  </label>
                  <div class="col-sm-8 flex-grow-1">
                    <div class="position-relative w-100">
                      <input
                        #issue_date="bsDatepicker"
                        type="text"
                        class="form-control modern-input text-uppercase w-100"
                        formControlName="issue_date"
                        id="issue_date"
                        placeholder="MM/DD/YYYY"
                        [bsConfig]="bsConfig"
                        [maxDate]="today"
                        [readOnly]="false"
                        bsDatepicker
                        appDateFormat
                        />
                        <i
                          class="fa-solid fa-calendar position-absolute"
              style="
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                color: #888;
              "
                          (click)="issue_date.show()"
                        ></i>
                      </div>
                      @if (
                        id_form.get('issue_date')?.errors?.['futureDate'] &&
                        id_form.get('issue_date')?.touched
                        ) {
                        <div
                          class="text-danger mt-1 small"
                          >
                          Issue date cannot be in the future.
                        </div>
                      }
                    </div>
                  </div>

                  <!-- Expiration Date -->
                  <div class="row align-items-center">
                    <label class="col-sm-4 col-form-label form-label text-end mb-0">
                      <span class="text-danger">*</span>Expiration Date:
                    </label>
                    <div class="col-sm-8 flex-grow-1">
                      <div class="position-relative w-100">
                        <input
                          #expiration_date="bsDatepicker"
                          type="text"
                          class="form-control modern-input text-uppercase w-100"
                          formControlName="expiration_date"
                          id="expiration_date"
                          placeholder="MM/DD/YYYY"
                          [bsConfig]="bsConfig"
                          [minDate]="today"
                          [readOnly]="false"
                          bsDatepicker
                          appDateFormat
                          />
                          <i
                            class="fa-solid fa-calendar position-absolute"
              style="
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                color: #888;
              "
                            (click)="expiration_date.show()"
                          ></i>
                        </div>
                        @if (
                          id_form.get('expiration_date')?.errors?.['pastDate'] &&
                          id_form.get('expiration_date')?.touched
                          ) {
                          <div
                            class="text-danger mt-1 small"
                            >
                            Expiration date has expired.
                          </div>
                        }
                      </div>
                    </div>

                    <!-- Sex -->
                    <div class="row align-items-center">
                      <label class="col-sm-4 col-form-label form-label text-end mb-0">
                        <span class="text-danger">*</span>Sex:
                      </label>
                      <div class="col-sm-8 flex-grow-1">
                        <ng-select
                          class="modern-input w-100"
                          [items]="sexOptions"
                          bindLabel="label"
                          bindValue="value"
                          [searchable]="false"
                          [clearable]="false"
                          formControlName="sex"
                        ></ng-select>
                      </div>
                    </div>
                  </div>

                  <!-- Buttons -->
                  <div class="d-flex justify-content-between mt-5 pt-2">
                    <!--Cancel-->
                    <button
                      type="button"
                      class="btn modern-btn secondary-btn px-4"
                      (click)="closeModalClick()"
                      >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      class="btn modern-btn primary-btn px-4"
                      [disabled]="id_form.invalid || !id_form.dirty"
                      >
                      Save
                    </button>
                  </div>
                </form>

                <div class="ms-4 mb-4">
                  <span class="text-danger">*</span>
                  <span class="text-light" style="font-size: 0.9rem"
                    >denotes required fields</span
                    >
                  </div>
                </div>

